import { ref } from '@vue/composition-api';
import usePersistedPerPage from '@/libs/utils/perPage';
// Notification
import { useToast } from 'vue-toastification/composition';
import useProfiles from '@/views/apps/roster/profile/useProfiles';

export default function useAccountImport() {
  // Use toast
  const toast = useToast();

  const refAccountSuccessTable = ref(null);
  const refAccountFailTable = ref(null);
  const refPaymentListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'hotkey', label: 'X' },
    { key: 'student.fullName', label: 'Name', stickyColumn: true, variant: 'primary' },
    { key: 'student.email', label: 'Email' },
    { key: 'profile', label: 'Profile' },
    // { key: 'cohort', label: 'Cohort' },
    { key: 'profile.attributes.fundingSource', label: 'Funding' },

    { key: 'payment.date', label: 'Date' },
    { key: 'payment.amount', label: 'Amount' },
    { key: 'payment.description', label: 'Description' },
    { key: 'status' },
    { key: 'actions' },
  ];

  const perPage = usePersistedPerPage('accountImport', 5);
  const totalPayments = ref(0);
  const currentPageFail = ref(1);
  const currentPageSuccess = ref(1);
  const perPageOptions = [5, 10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('createdAt');
  const isSortDirDesc = ref(true);

  const statusFilter = ref('');
  const fundingFilter = ref('');

  const dateFilter = ref('');

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const accountStatusOptions = [
    { label: 'Unpaid', value: 'unpaid' },
    { label: 'Partially Paid', value: 'partially_paid' },
    { label: 'Paid', value: 'paid' },
    { label: 'Overpaid', value: 'over_paid' },
    { label: 'Credited', value: 'credited' },
    { label: 'Refunded', value: 'refunded' },
    { label: 'Void', value: 'void' },
    { label: 'Archive', value: 'archived' },
  ];

  const paymentStatusOptions = [
    { label: 'Unpaid', value: 'unpaid' },
    { label: 'Paid', value: 'paid' },
    { label: 'Credited', value: 'credited' },
    { label: 'Over_paid', value: 'over_paid' },
    { label: 'Refunded', value: 'refunded' },
    { label: 'Reversed', value: 'reversed' },
    { label: 'Void', value: 'void' },
  ];

  const { fundingSourceOptions } = useProfiles();

  const yesNoOptions = [
    { label: 'N/A', value: 'na' },
    { label: 'No', value: 'no' },
    { label: 'Yes', value: 'yes' },
  ];

  return {
    tableColumns,
    perPage,
    currentPageFail,
    currentPageSuccess,
    totalPayments,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPaymentListTable,

    //

    accountStatusOptions,
    paymentStatusOptions,
    statusFilter,
    fundingSourceOptions,
    fundingFilter,
    yesNoOptions,
    dateFilter,
  };
}
